import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintStoreMap',
  setup(__props) {

const session = useEprintSession()
const actions = useEprintActions()
const konbiniMap = ref<HTMLElement | null>(null)

onMounted(() => {
  actions.bindMapEl(konbiniMap.value)
})
watch(konbiniMap, (el) => {
  actions.bindMapEl(el)
})
onBeforeUnmount(() => {
  actions.bindMapEl(null)
})

return { __sfc: true,session, actions, konbiniMap }
}

})